import { cuentasDeDemostracion as cuentasDelDemo, repositorioDemo } from './repositorio-demo.js'
import type { RepositorioJugador } from './tipos.js'

export * from './tipos.js'

let instancia: RepositorioJugador | null = null

/**
 * Los usuarios con los que se puede entrar a la demostración.
 *
 * Vacío cuando hay API: ahí las cuentas son de personas de verdad, y ofrecerlas
 * en la pantalla de ingreso sería publicar el padrón del club. La pantalla ya no
 * dibuja el panel cuando la lista viene vacía.
 */
export function cuentasDeDemostracion(): { nombre: string; usuario: string }[] {
  if (import.meta.env.VITE_API_URL) return []
  return cuentasDelDemo()
}

/**
 * De dónde salen los datos de la web.
 *
 * Del API si está configurado, y de la demostración si no. La condición es una
 * del entorno —`VITE_API_URL`, que Vite reemplaza al compilar— y no una bandera
 * que alguien pueda olvidarse de dar vuelta: una compilación para producción sin
 * esa variable no arranca con datos de mentira sin avisar, arranca con el cartel
 * de «demo» que la barra muestra siempre.
 *
 * Es el mismo criterio que usa la app de escritorio para elegir entre SQLite y su
 * propia demostración: la decisión la toma el entorno, una sola vez, y ninguna
 * pantalla se entera.
 *
 * La carga del cliente del API es dinámica para que su código no entre en el
 * paquete inicial cuando no se lo va a usar.
 */
export async function obtenerRepositorio(): Promise<RepositorioJugador> {
  if (instancia) return instancia

  const url = import.meta.env.VITE_API_URL
  if (url) {
    const { repositorioApi } = await import('./repositorio-api.js')
    instancia = repositorioApi(url)
  } else {
    instancia = repositorioDemo
  }

  return instancia
}
